import { AfterViewInit, Directive } from "@angular/core";
import { SegmentService } from "@main-services/segment.service";
import { RudderstackService } from "@main-services/rudderstack.service";

@Directive()
export abstract class PageTracker implements AfterViewInit {
	protected abstract trackingPageName: string;

	public constructor(
		protected segmentService: SegmentService,
		protected rudderstackService: RudderstackService
	) {}

	public ngAfterViewInit(): void {
		this.segmentService.page({ name: this.trackingPageName });
		this.rudderstackService.page({ name: this.trackingPageName });
	}
}
